import AboLadCodes from "@/utils/abo-lad-codes.js";
import { useMenuStore } from "@/store/menu";

export const usePageMerchAboLad = () => {
  const { merchAboLad } = storeToRefs(useMenuStore());
  const getAboLadData = (key) => {
    if (merchAboLad.value && merchAboLad.value.form_content) {
      const merch = (merchAboLad.value.form_content.find(merch => merch.key === key))
      return merch.value ? merch.value : null
    }
    return null
  }
  return {
    aboladcodes: AboLadCodes,
    merchAboLad,
    getAboLadData
  }
}